import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    container: {
      spacing: 'space-y-1',
      variants: {
        'default': 'p-2 md:p-4',
        'full-width': 'p-6 md:p-8'
      }
    },
    buttons: 'not-first:pt-4'
  },
} satisfies CMSConfig['bannerEspot']
